const data = {
  title: "Floor 1-8",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 11,
  tilesHeight: 5,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 3,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 3,
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 3,
      direction: "RIGHT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 3,
      direction: "RIGHT",
    },
    {
      type: "CONVEYOR",
      x: 4,
      y: 3,
      direction: "RIGHT",
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 6,
      y: 4,
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 1,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 1,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 5,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 5,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 1,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 5,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 8,
      y: 1,
    },
    {
      type: "WALL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "LOCK",
      x: 8,
      y: 3,
      color: "BLUE",
    },
    {
      type: "KEY",
      x: 6,
      y: 5,
      color: "BLUE",
    },
    {
      type: "CHIP",
      x: 6,
      y: 1,
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 2,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 4,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 2,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 4,
      direction: "DOWN",
    },
  ],
};

export default data;
